import { useEffect, useState, lazy, Suspense } from 'react';
import './App.css';
import './AgGrid.css';
import { Routes, Route } from "react-router-dom";

import { Mainlayout } from './Main_Layout_App/Mainlayout';
import { LoginLayout } from './Main_Layout_App/LoginLayout';
import PrivateRoute from './PrivateRoute';
import { CommonBaseURl } from './Commonprovider/CommonProvider';
import { useAutoLogout } from './CommonFunction/useAutoLogout';

// Lazy-loaded route components (Code Splitting)
const Login = lazy(() => import('./LoginComponent/Login').then(m => ({ default: m.Login || m.default })));
const Landing = lazy(() => import('./Components/Landing/Landing').then(m => ({ default: m.Landing || m.default })));
const Companyinfo = lazy(() => import('./Components/CompanyInfo_Common/Companyinfo').then(m => ({ default: m.Companyinfo || m.default })));
const Company = lazy(() => import('./Components/Components_Navigation/Company_Component/Company').then(m => ({ default: m.Company || m.default })));
const Industry = lazy(() => import('./Components/Components_Navigation/Industry_Component/Industry').then(m => ({ default: m.Industry || m.default })));
const Factsheet = lazy(() => import('./Components/Components_Navigation/Industry_Component/GeneralIndustry/Factsheet/Factsheet').then(m => ({ default: m.Factsheet || m.default })));
const House = lazy(() => import('./Components/Components_Navigation/House_Component/House').then(m => ({ default: m.House || m.default })));
const FactsheetHouse = lazy(() => import('./Components/Components_Navigation/House_Component/GeneralHouse/Factsheet/Factsheet').then(m => ({ default: m.FactsheetHouse || m.default })));
const Factsheetpeerset = lazy(() => import('./Components/Components_Navigation/Peerset_Component/FactsheetPeerset/Factsheet').then(m => ({ default: m.Factsheetpeerset || m.default })));
const Peerset = lazy(() => import('./Components/Components_Navigation/Peerset_Component/Peerset').then(m => ({ default: m.Peerset || m.default })));
const Ipo = lazy(() => import('./Components/Components_Navigation/Ipo_Component/Ipo').then(m => ({ default: m.Ipo || m.default })));
const IssuesOpen = lazy(() => import('./Components/Components_Navigation/Ipo_Component/IssuesIpo/IssuesOpen/IssuesOpen').then(m => ({ default: m.IssuesOpen || m.default })));
const Factsheetcomponent = lazy(() => import('./Components/Components_Navigation/Factsheet_Component/Factsheet').then(m => ({ default: m.Factsheetcomponent || m.default })));
const IndexFactsheet = lazy(() => import('./Components/Components_Navigation/Factsheet_Component/IndexFactsheet/IndexFactsheet').then(m => ({ default: m.IndexFactsheet || m.default })));
const FiiFpiTradingActivity = lazy(() => import('./Components/Components_Navigation/Reports_Analytics_Component/MfFiiDailyTurnoverCompany/FiiFpiTradingActivity/FiiFpiTradingActivity').then(m => ({ default: m.FiiFpiTradingActivity || m.default })));
const ReportsAnalytics = lazy(() => import('./Components/Components_Navigation/Reports_Analytics_Component/ReportsAnalytics').then(m => ({ default: m.ReportsAnalytics || m.default })));
const LiveApplication = lazy(() => import('./Components/Components_Navigation/LiveApplication_Component/LiveApplication').then(m => ({ default: m.LiveApplication || m.default })));
const ScreenerApp = lazy(() => import('./ScreenerComponent/ScreenerApp').then(m => ({ default: m.ScreenerApp || m.default })));
const CmLiveNewsMain = lazy(() => import('./Components/Components_Navigation/Cm-Live-News_Component/CmLiveNewsMain').then(m => ({ default: m.CmLiveNewsMain || m.default })));
const NotFound = lazy(() => import('./NotFound/NotFound').then(m => ({ default: m.NotFound || m.default })));
const IPLoginAccount = lazy(() => import('./LoginComponent/IPLoginForm/CreateIPLoginAccount/IPLoginAccount').then(m => ({ default: m.IPLoginAccount || m.default })));
const ExternalLoginAccount = lazy(() => import('./LoginComponent/ExternalAccessLogin/CreateExternalloginAccount/ExternalLoginAccount').then(m => ({ default: m.ExternalLoginAccount || m.default })));
const Watchlist = lazy(() => import('./Components/WatchList/Watchlist').then(m => ({ default: m.Watchlist || m.default })));
const MarketCommentary = lazy(() => import('./Components/Components_Navigation/Cm-Live-News_Component/Cm-Live-News/MarketCommentary/MarketCommentary').then(m => ({ default: m.MarketCommentary || m.default })));
const ForgotPassword = lazy(() => import('./LoginComponent/ForgotPassword/ForgotPassword').then(m => ({ default: m.default || m.ForgotPassword || m })));
const FinanceField = lazy(() => import('./Components/Components_Navigation/Company_Component/CustomizeScreen/FinanceField/FinanceField').then(m => ({ default: m.FinanceField || m.default })));
const CustomizeScreen = lazy(() => import('./Components/Components_Navigation/Company_Component/CustomizeScreen/CustomizeScreen').then(m => ({ default: m.CustomizeScreen || m.default })));
const FaceRegister = lazy(() => import('./LoginComponent/FaceLogin/FaceRegister').then(m => ({ default: m.default || m.FaceRegister || m })));
const FaceLogin = lazy(() => import('./LoginComponent/FaceLogin/FaceLogin').then(m => ({ default: m.default || m.FaceLogin || m })));
const TpScreener = lazy(() => import('./TP_Screener/src/App').then(m => ({ default: m.default || m })));
const EMagazineApp = lazy(() => import('./EMagazine/src/App').then(m => ({ default: m.default || m })));
const NewUserRegistration = lazy(() => import('./LoginComponent/NewUserRegistration/NewUserRegistration').then(m => ({ default: m.default || m.NewUserRegistration })));

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

function App() {
  const [BaseURL] = useState(CommonBaseURl);

  // Global 15-minute inactivity auto-logout across the entire project
  useAutoLogout();

  // 1. Context Menu / Copy Restriction Logic
  useEffect(() => {
    const allowedSelector = '#allowCopy';
    const handleContextMenu = (e) => { if (!e.target.closest(allowedSelector)) e.preventDefault(); };
    const handleCopy = (e) => { if (!e.target.closest(allowedSelector)) e.preventDefault(); };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("copy", handleCopy);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopy);
    };
  }, []);

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="/" element={<LoginLayout />}>
          {/* Normal Login at / */}
          <Route index element={<Login />} />
          
          {/* IP Login at /iplogin */}
          <Route path='iplogin' element={<Login iploginPage={true} />} />
          <Route path='externallogin' element={<Login externalurl={true} />} />

          {/* Registration Routes */}
          <Route path='register' element={<NewUserRegistration />} />
          <Route path='register.html' element={<NewUserRegistration />} />
          <Route path='newUser.html' element={<NewUserRegistration />} />
          <Route path='NewUserRegistration' element={<NewUserRegistration />} />
          <Route path='externalregister' element={<ExternalLoginAccount />} />
          <Route path='iplogin/register' element={<IPLoginAccount />} />

          {/* Other Auth Routes */}
          <Route path='faceRegister' element={<FaceRegister />} />
          <Route path='facelogin' element={<FaceLogin />} />
          <Route path='forgotpassword' element={<ForgotPassword />} />
        </Route>

        {/* Main Authenticated Routes */}
        <Route element={<PrivateRoute />}>
          <Route path='/watchlist' element={<Watchlist />} />
          <Route path="/screener/*" element={<ScreenerApp />} />
          <Route path='/tp-screener/*' element={<TpScreener />} />
          <Route path='/tp-screener' element={<TpScreener />} />
          <Route path='/e-magazine/*' element={<EMagazineApp />} />
          <Route path='/e-magazine' element={<EMagazineApp />} />

          <Route path="/*" element={<Mainlayout />}>
            <Route path='Landing' element={<Landing />} />
            <Route path='Companyinfo' element={<Companyinfo />} />
            <Route path='Company/*' element={<Company />} />
            <Route path='Industry/*' element={<Industry />} exact />
            <Route path='Industry/General/IndustryFactSheet' element={<Factsheet />} exact />

            <Route path='House/*' element={<House />} exact />
            <Route path='House/General/HouseFactSheet' element={<FactsheetHouse />} exact />

            <Route path='Peerset/*' element={<Peerset />} exact />
            <Route path='Peerset/Peerset/PeersetFactSheet' element={<Factsheetpeerset />} exact />

            <Route path='Ipo/*' element={<Ipo />} exact />
            <Route path='Ipo/IPO/IpoIssuesOpen' element={<IssuesOpen />} exact />

            <Route path='factSheet/*' element={<Factsheetcomponent />} />
            <Route path='factSheet/Index' element={<IndexFactsheet />} />

            <Route path='cmlivenews/*' element={<CmLiveNewsMain />} exact />
            <Route path='cmlivenews/cmlivenews/marketcommentary' element={<MarketCommentary />} exact />

            <Route path='reportsandanalytics/*' element={<ReportsAnalytics />} />
            <Route path='reportsandanalytics/mffiidailyturnover/fiifpitradingactivity' element={<FiiFpiTradingActivity />} />

            <Route path='liveapplication/*' element={<LiveApplication />} />
            <Route path='customizedscreen/*' element={<CustomizeScreen />} exact />
            <Route path='customizedscreen/customizedscreen/financefield' element={<FinanceField />} />
            <Route path='*' element={<NotFound />} />
          </Route>
        </Route>

        <Route path='*' element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

export default App;